import { useQuery } from '@tanstack/react-query';
import { fetchAnalyticsDashboard } from '../services/analytics.api';

export function useAnalyticsDashboard(params?: { from?: string; to?: string }) {
  return useQuery({
    queryKey: ['analytics', 'dashboard', params?.from ?? '', params?.to ?? ''],
    queryFn: () => fetchAnalyticsDashboard(params),
    staleTime: 60_000,
  });
}
